<script>
  // The login screen. One shared password -- there are no user accounts in this
  // app, which is worth knowing when reading the copy below.
  //
  // The old version bound `document.onkeydown` at module scope to catch Enter.
  // That is a global handler with no matching teardown, so it stayed installed
  // for the life of the page and fired login() from every other screen too. A
  // real <form> gives Enter-to-submit for free and only while focus is inside
  // it.
  import { apiFetch } from "../lib/api.js";

  let password = "";
  let errorMessage = "";
  let busy = false;

  async function login() {
    if (busy) return;
    busy = true;
    errorMessage = "";

    try {
      await apiFetch("/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      window.location.href = "/";
    } catch (err) {
      // A wrong password is a 401 now rather than 200 {success:false}, so this
      // branch also covers the server being unreachable -- show what happened
      // instead of always claiming the password was wrong.
      errorMessage = err.message;
    } finally {
      busy = false;
    }
  }
</script>

<div class="flex min-h-[70vh] items-center justify-center">
  <form class="w-full max-w-sm" on:submit|preventDefault={login}>
    <div class="surface p-7">
      <div class="mb-6 flex flex-col items-center gap-3 text-center">
        <img src="/RIC-Icon.png" alt="RIC" class="h-10 w-10 object-contain" />
        <div>
          <h1
            class="flex items-center justify-center gap-2 text-lg font-semibold"
          >
            RIC Dev Tool
            <span
              class="rounded-badge bg-secondary/10 px-1.5 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wider text-secondary"
            >
              Dev
            </span>
          </h1>
          <p class="mt-0.5 text-sm opacity-60">
            Internal tool. Enter the shared password.
          </p>
        </div>
      </div>

      <label class="block">
        <span class="mb-1 block text-xs opacity-60">Password</span>
        <input
          type="password"
          class="input input-bordered w-full"
          autocomplete="current-password"
          bind:value={password}
        />
      </label>

      <button
        class="btn btn-primary mt-4 w-full normal-case"
        type="submit"
        disabled={busy}
      >
        {#if busy}
          <i class="fas fa-spinner fa-spin text-xs" aria-hidden="true"></i>
        {/if}
        Sign in
      </button>

      {#if errorMessage}
        <p class="mt-3 flex items-center gap-2 text-sm text-error">
          <i class="fas fa-exclamation-circle text-xs" aria-hidden="true"></i>
          {errorMessage}
        </p>
      {/if}
    </div>
  </form>
</div>
